window.initializeAddToCollectionPopover = () => {
    $('.meta-stat.collect').each((index, metaCollect) => {
        const obj = $(metaCollect);
        const visualizationID = obj.data('visualization');

        if ('undefined' !== typeof visualizationID) {
            obj.on('mouseup', (evt) => {
                evt.stopPropagation();
                evt.preventDefault();

                Livewire.emit('addVisualizationIDToCollection', visualizationID);

                const popover = $('.add-to-collection-popover');

                new Popper(evt.target, popover[0], {
                    placement: 'top',
                });

                $(popover).addClass('d-block');
            });
        }
    });
};

$(() => {
    $(document).on('mouseup', () => $('.add-to-collection-popover').removeClass('d-block'));

    $('.add-to-collection-popover *').on('mouseup', (evt) => {
        evt.stopPropagation();
    });

    $('.add-to-collection-popover .dismiss').on('mouseup', (e) => {
        e.stopPropagation();
        e.preventDefault();
        $('.add-to-collection-popover').removeClass('d-block')
    });

    initializeAddToCollectionPopover();

    Livewire.on('renderPage', () => {
        initializeAddToCollectionPopover();
    });
});
